function e() {
  var n;
  try {
    return (n = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : n.cookie.split(";").map((o) => o.split("=")).reduce((o, [t, r]) => (o[decodeURIComponent(t == null ? void 0 : t.trim())] = decodeURIComponent(r == null ? void 0 : r.trim()), o), {});
  } catch {
    return {};
  }
}
export {
  e as parseCookie
};
